import React from 'react';

const Otherincome = () => {
    return (
        <div>
            
        </div>
    )
}

export default Otherincome;
